import colorYellow from '@material-ui/core/colors/yellow'

const styles = theme => ({
  highlight: {
    display: 'inline-block',
    backgroundColor: colorYellow[400],
    color: 'inherit',
  },
})

export default styles
